import clsx from 'clsx';
import __isEmpty from 'lodash/isEmpty';
import Link from 'next/link';
import { setStorageValue } from '@portal-internet/core';
import { getUrlFriendly } from './RouteResolver';
import { useRouter } from 'next/router';
import styles from './enllac.module.scss';
import { forwardRef } from 'react';
import { getRedirect } from './redirects';

const _getUrl = (props) => {
    const { type, route } = props;
    return getUrlFriendly({ producte: 'web_noticies', ...props, ...route, routePath: route?.type || type });
};

const _normalizePath = (path) => {
    if (!path) return '/';
    return path.endsWith('/') && path !== '/' ? path.slice(0, -1) : path;
};

const Enllac = forwardRef((props, ref) => {
    const {
        titol = '',
        href = '',
        estil = '',
        novaFinestra = false,
        className,
        route,
        rel,
        dataTestId,
        ariaLabel,
        title,
        role,
        tabIndex,
        onClick,
        onKeyDown,
        marcatgeAudienciesClick,
        redirect
    } = props;
    const router = useRouter();
    const styleLink = clsx({
        [styles[estil]]: !__isEmpty(estil),
        [className]: !__isEmpty(className)
    });

    let hrefLink = route?.href || href;
    if (__isEmpty(hrefLink)) {
        hrefLink = _getUrl(props);
    }
    hrefLink = getRedirect(hrefLink, redirect);

    const setStorageClick = () => {
        const dataClickOrigin = {
            name: marcatgeAudienciesClick
        };
        setStorageValue('ccma_click', dataClickOrigin, { path: '/', domain: '.3cat.cat', expires: 1 });
    };

    const handleLinkClick = () => {
        if (onClick) onClick();
        if (marcatgeAudienciesClick) setStorageClick();
        if (!novaFinestra && _normalizePath(hrefLink) === _normalizePath(router.asPath)) {
            router.reload();
        }
    };

    if (hrefLink.startsWith('/3catinfo/')) {
        return (
            <Link
                href={hrefLink}
                scroll={false}
                className={styleLink || null}
                target={novaFinestra ? '_blank' : null}
                rel={novaFinestra ? 'noreferrer' : rel}
                data-testid={dataTestId}
                aria-label={ariaLabel}
                title={title}
                role={role}
                onClick={handleLinkClick}
                onKeyDown={onKeyDown}
                ref={ref}
                tabIndex={tabIndex}
            >
                {titol || props.children}
            </Link>
        );
    } else {
        return (
            <a
                onClick={handleLinkClick}
                onKeyDown={onKeyDown}
                className={styleLink || null}
                target={novaFinestra ? '_blank' : null}
                rel={novaFinestra ? 'noreferrer' : rel}
                data-testid={dataTestId}
                aria-label={ariaLabel}
                title={title}
                role={role}
                href={hrefLink}
                ref={ref}
                tabIndex={tabIndex}
            >
                {titol || props.children}
            </a>
        );
    }
});

Enllac.displayName = 'Enllac';
export default Enllac;
